import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { CP_ICONS } from '../../shared/icons';
import { OFFER_FIELDS, SAMPLE_OPTIONS, SAMPLE_REQUESTS, formatUsd } from './sample-data';

/** Static rendering of a lender response: up to three options compared side by side. */
@Component({
  selector: 'app-offers-preview',
  standalone: true,
  imports: [NgIcon],
  viewProviders: [provideIcons(CP_ICONS)],
  templateUrl: './offers-preview.component.html',
})
export class OffersPreviewComponent {
  readonly request = SAMPLE_REQUESTS[0];
  readonly options = SAMPLE_OPTIONS;
  readonly fields = OFFER_FIELDS;
  readonly selectedIndex = 0;

  usd(value: number): string {
    return formatUsd(value);
  }
}
